// import bckImg from '../../assets/images/landing_bg.jpg' // Hot Pink
const centerDistance = '150px'
const partionHeadToBody = 5
const footerHeight = 0
const backgroundColor2 = 'rgba(245,245,245,1)' //Light Gray
const backgroundColor1 = 'rgba(237,67,106,1)'
const addContactButtonColor = 'rgba(121,224,19,1)'

const styles = theme => ({
  app: {
    height: '100vh', //forces filling 100% of view
    // textAlign: 'center',
    display: 'flex',
    flexDirection: 'column'
    // backgroundImage: `url(${bckImg})`
  },
  name: {
    color: '#fff',
    padding: '10px'
  },
  header: {
    height: `${partionHeadToBody}vh`,
    backgroundColor: backgroundColor1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center' // Horizontal
    // backgroundImage: `url(${bckImg})`
  },
  photo: {
    height: centerDistance,
    width: centerDistance,
    backgroundColor: backgroundColor1,
    textAlign: 'center',
    // borderRadius: '50%',
    lineHeight: centerDistance //Vertically Centers Text if = to height and width
  },
  body: {
    height: `${100 - partionHeadToBody - footerHeight}%`,
    backgroundColor: backgroundColor2,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0% 8% 8%'
  },
  text: {
    fontSize: '62.5%',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'space-evenly', //Vertical Center
    alignItems: 'center',
    flexDirection: 'column'
  },
  footer: {
    height: `${footerHeight}%`,
    display: 'flex',
    justifyContent: 'flex-end', //Vertical Center
    alignItems: 'center',
    flexDirection: 'row',
    padding: 20,
    backgroundColor: backgroundColor2
  },
  footerBoxText: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding: '8px',
    margin: '0px',
    alignItems: 'center'
    // width: '100%'
  },
  notifiy: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '8px',
    margin: '0px',
    width: '100%'
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding: '24px 28px',
    margin: '0px 0px',
    backgroundColor: backgroundColor2,
    alignItems: 'center'
  },
  // footerBox: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   flexDirection: 'row',
  //   alignContent: 'space-between',
  //   justifyContent: 'space-between',
  //   padding: '10px 10px 14px 15px'
  // },
  cards: {
    margin: '10px'
  },

  footerButton: {
    backgroundColor: backgroundColor1,
    borderRadius: '5px'
  },
  fab: {
    display: 'block',
    position: 'fixed',
    transform: `translate(calc(100vw - 100px), calc(40vh - 30px))`,
    backgroundColor: addContactButtonColor
  },
  row: {
    display: 'flex',
    justifyContent: 'center'
  },
  avatar: {
    margin: 10
  },
  bigAvatar: {
    width: centerDistance,
    height: centerDistance
  },

  dotWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    clear: 'both'
  },

  small: {
    borderRadius: '25%',
    backgroundColor: 'rgba(234,168,182,1)',
    height: '10px',
    width: '5px',
    margin: '2px'
  },

  big: {
    borderRadius: '50px',
    backgroundColor: 'rgba(234,168,182,1)',
    height: '20px',
    width: '5px',
    margin: '2px'
  },
  smallBottom: {
    borderRadius: '50%',
    backgroundColor: 'rgba(234,168,182,1)',
    height: '10px',
    width: '10px',
    margin: '2px'
  },

  bigBottom: {
    borderRadius: '50px',
    backgroundColor: 'rgba(234,168,182,1)',
    height: '20px',
    width: '10px',
    margin: '2px'
  },
  cardRight: {
    // transform: 'translate(166px, -48px)',
    maxWidth: '135px',
    // position: 'absolute'
    float: 'right',
    marginTop: '-48px',
    marginBottom: '-24px'
  },

  cardLeft: {
    // transform: 'translate(0px, -48px)',
    // maxWidth: '135px',
    // position: 'absolute'
    // transform: 'translate(166px, -48px)',
    maxWidth: '135px',
    // position: 'absolute'
    float: 'left',
    marginTop: '-48px',
    marginBottom: '-24px'
  },
  timelineSection: {
    marginBottom: '-85px'
  },
  iconLeft: {
    transform: 'scaleX(-1)'
  },
  footerBoxTextNotify: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding: '8px',
    margin: '0px',
    alignItems: 'center',
    width: '100%'
  },
  notifiedText: {
    color: 'secondary',
    fontWeight: 'bold',
    fontSize: '0.7rem'
  },
  personInNotifiedText: {
    fontSize: '0.7rem'
  },
  titleInNotifiedText: {
    color: '#aaa',
    fontSize: '0.8rem'
  }
})

export default styles
